import { assignWithDefined } from './axel/util';

export interface TreeNode {
  key: any;
  name: string;
  icon: string;
  disabled: boolean;
  selected?: boolean;
  props?: TreeNodeProps;
  nodes?: TreeNode[];
}

export interface TreeNodeProps {
  [key: string]: string;
}

export function treeNodeFactory(
  key: any,
  name: string,
  props?: TreeNodeProps,
  nodes: TreeNode[] = [],
  icon?: string,
  disabled = false
): TreeNode {
  return assignWithDefined({}, { key, name, props, nodes, icon, disabled });
}

export function walkTreeNodes(nodes: TreeNode[], callback: (node: TreeNode) => void) {
  for (const node of nodes) {
    callback(node);
    if (node && node.nodes.length) {
      walkTreeNodes(node.nodes, callback);
    }
  }
}
